import SelfRating from './SelfRating';

export default SelfRating;
